'use client';
import { jsx } from 'react/jsx-runtime';
import t$1 from 'prop-types';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(o, s) {
    if (null == o) return {};
    var n, e, l = _object_without_properties_loose(o, s);
    if (Object.getOwnPropertySymbols) {
        var t = Object.getOwnPropertySymbols(o);
        for(e = 0; e < t.length; e++)n = t[e], !(s.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(o, n) && (l[n] = o[n]);
    }
    return l;
}
function _object_without_properties_loose(o, s) {
    if (null == o) return {};
    var n, e, l = {}, t = Object.keys(o);
    for(e = 0; e < t.length; e++)n = t[e], s.indexOf(n) >= 0 || (l[n] = o[n]);
    return l;
}
let l = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
], t = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
], p = Object.keys({
    span: t$1.oneOf(l).isRequired,
    spanXs: t$1.oneOf(l),
    spanSm: t$1.oneOf(l),
    spanMd: t$1.oneOf(l),
    spanLg: t$1.oneOf(l),
    spanXl: t$1.oneOf(l),
    offset: t$1.oneOf(t),
    offsetSm: t$1.oneOf(t),
    offsetMd: t$1.oneOf(t),
    offsetLg: t$1.oneOf(t),
    offsetXl: t$1.oneOf(t),
    push: t$1.oneOf(t),
    pushSm: t$1.oneOf(t),
    pushMd: t$1.oneOf(t),
    pushLg: t$1.oneOf(t),
    pushXl: t$1.oneOf(t),
    pull: t$1.oneOf(t),
    pullSm: t$1.oneOf(t),
    pullMd: t$1.oneOf(t),
    pullLg: t$1.oneOf(t),
    pullXl: t$1.oneOf(t),
    flexColumn: t$1.bool,
    verticallyCenterContent: t$1.bool,
    sticky: t$1.bool,
    unsticky: t$1.oneOf([
        'none',
        'xs'
    ]),
    floatingContainer: t$1.bool,
    floatingContainerAlignment: t$1.oneOf([
        'left',
        'right'
    ])
});
const Column = renderWithRef('Column', null, (s, e)=>{
    var { children: l } = s, t = _object_without_properties(s, [
        "children"
    ]);
    let { span: u, spanXs: f, spanSm: r, spanMd: i, spanLg: a, spanXl: c, offset: h, offsetSm: d, offsetMd: w, offsetLg: O, offsetXl: m, push: v, pushSm: $, pushMd: g, pushLg: b, pushXl: y, pull: x, pullSm: _, pullMd: j, pullLg: C, pullXl: k, flexColumn: S = false, verticallyCenterContent: X = false, sticky: L = false, unsticky: M = 'none', floatingContainer: R = false, floatingContainerAlignment: P = 'left' } = t, q = [
        `swan-col-${u}`
    ];
    return void 0 !== f && q.push(`swan-col-xs-${f}`), void 0 !== r && q.push(`swan-col-sm-${r}`), void 0 !== i && q.push(`swan-col-md-${i}`), void 0 !== a && q.push(`swan-col-lg-${a}`), void 0 !== c && q.push(`swan-col-xl-${c}`), void 0 !== h && q.push(`swan-col-offset-${h}`), void 0 !== d && q.push(`swan-col-sm-offset-${d}`), void 0 !== w && q.push(`swan-col-md-offset-${w}`), void 0 !== O && q.push(`swan-col-lg-offset-${O}`), void 0 !== m && q.push(`swan-col-xl-offset-${m}`), void 0 !== x && q.push(`swan-col-pull-${x}`), void 0 !== _ && q.push(`swan-col-sm-pull-${_}`), void 0 !== j && q.push(`swan-col-md-pull-${j}`), void 0 !== C && q.push(`swan-col-lg-pull-${C}`), void 0 !== k && q.push(`swan-col-xl-pull-${k}`), void 0 !== v && q.push(`swan-col-push-${v}`), void 0 !== $ && q.push(`swan-col-sm-push-${$}`), void 0 !== g && q.push(`swan-col-md-push-${g}`), void 0 !== b && q.push(`swan-col-lg-push-${b}`), void 0 !== y && q.push(`swan-col-xl-push-${y}`), S && q.push('swan-col-flex-column'), X && q.push('swan-col-vertically-center'), L && q.push('swan-col-sticky'), 'xs' === M && q.push('swan-col-unsticky-xs'), R && q.push('swan-floating-container'), 'right' === P && q.push('swan-floating-container-right'), jsx(RenderComp, {
        root: "div",
        forwardedRef: e,
        props: t,
        propKeysToRemove: p,
        classNames: q,
        children: l
    });
});

export { Column };
